import { MediaContext } from "/@src/views/app/MediaProvider";

const MediaProvider = ({ children }) => {

  const selectMedia = async (onSelect, type, allowedType) => {
    const mapType = {
      image: "image/*",
      "3dModel": "application/octet-stream",
    };
    var fileFrame = wp.media({
      title: "Select Media",
      button: { text: "Select Media" },
      multiple: false,
      library: {
        type: mapType[type],
      },
    });

    fileFrame.on("select", function () {
      var attachment = fileFrame.state().get("selection").first().toJSON();

      // Ensure file extension is .glb
      if (type === "3dModel" && !attachment.url.endsWith(".glb")) {
        alert("Please select a valid .glb 3D model file.");
        return;
      }
        onSelect({
            mediaId: attachment.id,
            mediaUrl: attachment.url,
            mimeType: attachment.mime,
            altText: attachment.alt,
            fileName: attachment.filename,
        });

    });

    fileFrame.open();
  };

  return (
    <MediaContext.Provider value={{ mediaSelector: selectMedia }}>
      {children}
    </MediaContext.Provider>
  );
};

export default MediaProvider;
